import LeagueCheck from "../components/leagueCheck/leagueCheck";

export default function LeagueCheckPage() {
  return (
    <LeagueCheck />
  );
}